(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  document.querySelectorAll('newsletter-popup.ax-welcome').forEach((popup) => {
    if (popup.hasAttribute('data-welcome-submitted')) {
      try {
        localStorage.setItem('theme:popup-filled', 'true');
      } catch {}
    }
    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.hasAttribute('open')) {
        popup.hide();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
